import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "styled-components";
import { color, units } from "@m/alchemy-theme";
import { LoadingIndicator } from "../../progress/loading-indicator/LoadingIndicator";
const ListItem = styled.li `
  display: block;
  padding: ${units(1)} ${units(2)};
  position: relative;
  min-height: ${units(4.375)};
  background-color: ${color("container")};
`;
export const SelectLoadingOption = forwardRef((props, ref) => (_jsx(ListItem, { ref: ref, children: _jsx(LoadingIndicator, { ...props }) })));
SelectLoadingOption.displayName = "SelectLoadingOption";
